export default "__VITE_ASSET__CclA82Hh__"